/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  Note,
  NoteRequest,
  PatchedNoteRequest
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const notesList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note[]>(
      {url: `/all/notes/`, method: 'GET', signal
    },
      options);
    }




export const getNotesListQueryKey = () => {
    return [
    `/all/notes/`
    ] as const;
    }


export const getNotesListQueryOptions = <TData = Awaited<ReturnType<typeof notesList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notesList>>> = ({ signal }) => notesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotesListQueryResult = NonNullable<Awaited<ReturnType<typeof notesList>>>
export type NotesListQueryError = ErrorType<ApiError>


export function useNotesList<TData = Awaited<ReturnType<typeof notesList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notesList>>,
          TError,
          Awaited<ReturnType<typeof notesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotesList<TData = Awaited<ReturnType<typeof notesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notesList>>,
          TError,
          Awaited<ReturnType<typeof notesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotesList<TData = Awaited<ReturnType<typeof notesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotesList<TData = Awaited<ReturnType<typeof notesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const notesCreate = (
    noteRequest: NoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/all/notes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteRequest, signal
    },
      options);
    }




export const getNotesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesCreate>>, TError,{data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notesCreate>>, TError,{data: NoteRequest}, TContext> => {

const mutationKey = ['notesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notesCreate>>, {data: NoteRequest}> = (props) => {
          const {data} = props ?? {};

          return  notesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notesCreate>>>
    export type NotesCreateMutationBody = NoteRequest
    export type NotesCreateMutationError = ErrorType<ApiError>

    export const useNotesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesCreate>>, TError,{data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notesCreate>>,
        TError,
        {data: NoteRequest},
        TContext
      > => {
      return useMutation(getNotesCreateMutationOptions(options), queryClient);
    }
    export const notesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/all/notes/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getNotesRetrieveQueryKey = (id: number,) => {
    return [
    `/all/notes/${id}/`
    ] as const;
    }


export const getNotesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof notesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notesRetrieve>>> = ({ signal }) => notesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof notesRetrieve>>>
export type NotesRetrieveQueryError = ErrorType<ApiError>


export function useNotesRetrieve<TData = Awaited<ReturnType<typeof notesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotesRetrieve<TData = Awaited<ReturnType<typeof notesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotesRetrieve<TData = Awaited<ReturnType<typeof notesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotesRetrieve<TData = Awaited<ReturnType<typeof notesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const notesUpdate = (
    id: number,
    noteRequest: NoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/all/notes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: noteRequest, signal
    },
      options);
    }




export const getNotesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesUpdate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notesUpdate>>, TError,{id: number;data: NoteRequest}, TContext> => {

const mutationKey = ['notesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notesUpdate>>, {id: number;data: NoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  notesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof notesUpdate>>>
    export type NotesUpdateMutationBody = NoteRequest
    export type NotesUpdateMutationError = ErrorType<ApiError>

    export const useNotesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesUpdate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notesUpdate>>,
        TError,
        {id: number;data: NoteRequest},
        TContext
      > => {
      return useMutation(getNotesUpdateMutationOptions(options), queryClient);
    }
    export const notesPartialUpdate = (
    id: number,
    patchedNoteRequest?: PatchedNoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/all/notes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNoteRequest, signal
    },
      options);
    }




export const getNotesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext> => {

const mutationKey = ['notesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notesPartialUpdate>>, {id: number;data?: PatchedNoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  notesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof notesPartialUpdate>>>
    export type NotesPartialUpdateMutationBody = PatchedNoteRequest | undefined
    export type NotesPartialUpdateMutationError = ErrorType<ApiError>

    export const useNotesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNoteRequest},
        TContext
      > => {
      return useMutation(getNotesPartialUpdateMutationOptions(options), queryClient);
    }
    export const notesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/all/notes/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getNotesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['notesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  notesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof notesDestroy>>>

    export type NotesDestroyMutationError = ErrorType<ApiError>

    export const useNotesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getNotesDestroyMutationOptions(options), queryClient);
    }
    export const notesMarkAsReadCreate = (
    id: number,
    noteRequest: NoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/all/notes/${id}/mark_as_read/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteRequest, signal
    },
      options);
    }




export const getNotesMarkAsReadCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesMarkAsReadCreate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notesMarkAsReadCreate>>, TError,{id: number;data: NoteRequest}, TContext> => {

const mutationKey = ['notesMarkAsReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notesMarkAsReadCreate>>, {id: number;data: NoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  notesMarkAsReadCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotesMarkAsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notesMarkAsReadCreate>>>
    export type NotesMarkAsReadCreateMutationBody = NoteRequest
    export type NotesMarkAsReadCreateMutationError = ErrorType<ApiError>

    export const useNotesMarkAsReadCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notesMarkAsReadCreate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notesMarkAsReadCreate>>,
        TError,
        {id: number;data: NoteRequest},
        TContext
      > => {
      return useMutation(getNotesMarkAsReadCreateMutationOptions(options), queryClient);
    }
